import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'app-flow-filter',
    templateUrl: './flow-filter.component.html',
    styleUrls: ['./flow-filter.component.scss'],
    imports: [ReactiveFormsModule, NgSelectModule]
})
export class FlowFilterComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() flows;
  flowSelect;
  @Output() flowSelected = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }
}
